import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { ResizeController } from '../../controllers/resize-controller';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './tufts-side-by-side.css.lit';

/**
 * The TuftsSideBySide component
 * @element tufts-side-by-side
 */
@customElement('tufts-side-by-side')
export class TuftsSideBySide extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  resizeController: ResizeController = new ResizeController(this, {
    breakpoints: [700],
  });

  @property({ type: String, reflect: true }) side: string;

  render(): TemplateResult {
    const classes = {
      'side-by-side-container': true,
      'isMobile': this.resizeController.currentBreakpointRange === 0,
      [this.side]: !!this.side,
    };
    return html`
      <div class="${classMap(classes)}">
        <div class="side-container">
          <slot name="side-content"></slot>
        </div>
        <div class="content-container">
          <slot name="main-content"></slot>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-side-by-side': TuftsSideBySide;
  }
}
